import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// project imports

import { useSelector } from "react-redux";
import { dispatch } from "store";
import { AUTH_FAIL } from "store/actions";
import setAuthToken from "Helpers/setAuthToken";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const { isAuthenticated, loading } = auth
  const navigate = useNavigate();
  const token = localStorage.getItem("MILITARY_USER_TOKEN")

  useEffect(() => {
    if (!token) {
      dispatch({
        type: AUTH_FAIL,
      });
      setAuthToken(null)
    }
    if ((!isAuthenticated || isAuthenticated === false) && loading === true) {
      navigate("login", { replace: true });
    }
  }, [isAuthenticated, loading, navigate, token]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
